<li role="menuitem" 
	class="item" 
	*ngFor="let action of actions; let i = index;" 
	dropdown 
	id="drop-menuitem-{{i}}"
	#dropdown="bs-dropdown" 
	style="z-index: 100" 
	(isOpenChange)="changeItemStatus($event, i, dropdown)">
	<button id="drop-item-{{i}}" class="dropdown-item" dropdownToggle (click)='execAction(action, $event, i)'>
		<i class="fa fa-caret-left" 
			*ngIf="action.ChildActions 
				|| action.ActionType === _actionTypes.VerticalSlider
				|| action.ActionType === _actionTypes.HorizontalSlider"></i> 
		{{ action.Description }}
	</button>
	<ng-container *ngIf="action.ChildActions 
		|| action.ActionType === _actionTypes.VerticalSlider
		|| action.ActionType === _actionTypes.HorizontalSlider">
		<div *dropdownMenu class="dropdown-menu dropdown-menu-right sub">
			<app-drop-item *ngIf="action.ActionType !== _actionTypes.VerticalSlider && action.ActionType !== _actionTypes.HorizontalSlider" [actions]="action.ChildActions"></app-drop-item>
			<div *ngIf="action.ActionType === _actionTypes.VerticalSlider || action.ActionType === _actionTypes.HorizontalSlider">
				<app-input-range
					[min]="action.SliderRange.MinimumValue" 
					[max]="action.SliderRange.MaximumValue" 
					[step]="(action.SliderRange.Step) ? action.SliderRange.Step : 1" 
					[value]="action.CurrentValue.Value"
					[vertical]="action.ActionType === _actionTypes.VerticalSlider"
					(change)="execAction(action, $event, i)"
				></app-input-range>
			</div>
		</div>
	</ng-container>
</li>

<li class="item dropdown-loader" *ngIf="actions === null">
	<i  class="fas fa-circle-notch fa-spin fa-1x fa-fw"></i>
</li>

<li class="item dropdown-loader" *ngIf="actions?.length === 0">
	<p class="mb-0">{{ appService.CoreCommonLiterals.NoActions }}</p>
</li>